import { pastille } from '@rh/shared';

/**
 * Pastille de potentiel (docs/BAREME.md § 1). La couleur ne va jamais seule :
 * le chiffre est inscrit dedans et le libellé est donné au survol, pour rester
 * lisible en daltonisme et à l'impression noir et blanc.
 *
 * `libelle` écrit ce mot en clair à côté du chiffre (demande du 2026-09-19) :
 * un survol n'existe pas sur téléphone, et « 3 » ne dit rien tant qu'on n'a
 * pas appris l'échelle. Il se met sous le chiffre à l'étroit, à côté au large.
 * Caché aux lecteurs d'écran : l'`aria-label` de la pastille le dit déjà.
 */
export function Pastille({
  valeur,
  libelle = false,
  etiquette = null,
}: {
  valeur: number | null;
  libelle?: boolean;
  /** Mot libre du recruteur, écrit devant le chiffre : « comptabilité », « vente »… */
  etiquette?: string | null;
}) {
  const niveau = pastille(valeur);
  const chiffre = (
    <span
      className="pastille"
      style={{ background: niveau.couleur }}
      title={niveau.libelle}
      aria-label={`Potentiel : ${niveau.libelle}`}
    >
      {niveau.valeur ?? '—'}
    </span>
  );
  if (!libelle && !etiquette) return chiffre;
  return (
    <span className="bloc-pastille">
      <span className="tete-pastille">
        {etiquette && <span className="etiquette-profil">{etiquette}</span>}
        {chiffre}
      </span>
      {libelle && (
        <small className="mot-pastille" aria-hidden="true">
          {niveau.libelle}
        </small>
      )}
    </span>
  );
}

export function Note({ valeur, date }: { valeur: number | null; date: string | null }) {
  if (valeur === null) return null;
  return (
    <span className="note" title={date ? `Évaluée le ${new Date(date).toLocaleDateString('fr-FR')}` : undefined}>
      <strong>{valeur.toFixed(1)}</strong>
      <small>/5</small>
    </span>
  );
}
